import React from 'react';
import './Page.css';

function Contact() {
  return (
    <div className="App">
      <div className="header">
        <h1>Contact Us</h1>
      </div>

      <div className="card">
        <div className="page-content">
          <h2>Get in Touch</h2>
          <p>
            We'd love to hear from you! Whether you have questions, feedback, or just want
            to say hello, feel free to reach out.
          </p>

          <h3>Customer Support</h3>
          <p>
            For questions about orders, delivery, or technical issues, please contact our
            support team:
          </p>
          <p>
            <strong>Email:</strong> support@emojipostcard.com
          </p>

          <h3>General Inquiries</h3>
          <p>
            For partnerships, press inquiries, or other general questions:
          </p>
          <p>
            <strong>Email:</strong> hello@emojipostcard.com
          </p>

          <h3>Follow Us</h3>
          <p>
            Stay updated with our latest emoji collections and special offers by following
            us on social media.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
